<div class="td-wb-system-error__wrap"
     [class.td-wb-system-error--enter]="animationState() === 'enter'"
     [class.td-wb-system-error--exit]="animationState() === 'exit'"
     (animationend)="onAnimationDone($event)">
  <td-wb-notification notificationType="info">
    <div class="td-wb-system-error__content">
      <div translate="tdWb.systemErrorDialog.MESSAGE"></div>
    </div>
    <td-wb-notification-close-button id="td-wb-system-error__close-button"
                                     aria-label="tdWb.systemErrorDialog.CLOSE_ARIA"
                                     (click)="startExiting($event)" />
  </td-wb-notification>
</div>
